import * as yup from 'yup';
import { headSiteData } from '../api/siteRequest';
import messages from './messages';
import { getPhoneNumberValidation } from './user/userCommonValidations';

export function getApartmentValidationSchema(companyId, siteId, formatMessage, initValues = {}) {
  return {
    floor: yup
      .string()
      .optional()
      .max(255, formatMessage(messages.useApartmentFormValidationSchemaMaxLengthFloor))
      .matches(/^(?!\s+$)/, formatMessage(messages.useApartmentFormValidationSchemaInvalidValue)),
    gsmCallsInApartments: yup.array().of(
      yup.object().shape({
        apartmentId: yup.string(),
        gsmCalls: yup.boolean(),
        phoneNumber: getPhoneNumberValidation(formatMessage),
      })
    ),
    hasForm: yup.boolean(),
    name: yup.string().when('hasForm', {
      is: true,
      then: (schema) =>
        schema
          .max(255, formatMessage(messages.useApartmentFormValidationSchemaMaxLengthName))
          .matches(/^(?!\s+$)/, formatMessage(messages.useApartmentFormValidationSchemaInvalidValue)),
    }),
    number: yup.string().when('hasForm', {
      is: true,
      then: (schema) =>
        schema
          .required(formatMessage(messages.useApartmentFormValidationSchemaRequiredNumber))
          .max(255, formatMessage(messages.useApartmentFormValidationSchemaMaxLengthNumber))
          .matches(/^\s*\S.*$/, formatMessage(messages.useApartmentFormValidationSchemaInvalidValue))
          .test({
            message: formatMessage(messages.useApartmentFormValidationSchemaExistNumber),
            name: 'isExistNumber',
            test: async function (number) {
              const floorName = this.parent.floor || undefined;

              const originalNumber = initValues.number || '';
              const originalFloor = initValues.floor || '';
              const hasChanged = (number || '') !== originalNumber || (floorName || '') !== originalFloor;

              if (!hasChanged) {
                return true;
              }

              try {
                if (!number || number.length === 0) {
                  return true;
                }
                let state = true;
                await headSiteData({ companyId, siteId }, 'apartments', { floorName, number }, false).then(
                  (response) => {
                    state = response.status === 404;
                  }
                );

                return state;
              } catch {
                return true;
              }
            },
          }),
    }),
    phoneNumber: getPhoneNumberValidation(formatMessage),
  };
}
